// TODO: Merge this implementation with TagManagerProvider component.
import TagManager from 'react-gtm-module';
export const useTagManager = () => {
    const trigger = (name, parameters) => {
        TagManager.dataLayer({ dataLayer: { event: name, ...parameters } });
    };
    return { trigger };
};
